import api from "./axios";

export interface WarehouseStockDto {
  productId: number;
  quantity: number;
  product: {
    id: number;
    nameRu: string;
    sku?: string;
    type: "product" | "service";
    imageUrl?: string;
    categoryId?: number;
    category?: { id: number; name: string };
  };
}

export async function getWarehouseStock(): Promise<WarehouseStockDto[]> {
  const res = await api.get("/warehouse/stock");
  return res.data;
}
